import { faAtom, faCode, faDatabase, faRocket } from '@fortawesome/free-solid-svg-icons'
import { faBootstrap, faCss3Alt, faHtml5, faJsSquare, faNodeJs, faPhp, faReact, faSass } from '@fortawesome/free-brands-svg-icons'

const techs = [
    {
        title: 'Frontend Development',
        techs: [
            {
                name: 'HTML',
                icon: faHtml5,
                exp: 'Experienced'
            },
            {
                name: 'CSS',
                icon: faCss3Alt,
                exp: 'Experienced'
            },
            {
                name: 'Scss / Sass',
                icon: faSass,
                exp: 'Entry'
            },
            {
                name: 'JavaScript',
                icon: faJsSquare,
                exp: 'Expert'
            },
            {
                name: 'jQuery',
                icon: faJsSquare,
                exp: 'Intermediate'
            },
            {
                name: 'Ajax',
                icon: faJsSquare,
                exp: 'Experienced'
            },
            {
                name: 'React',
                icon: faReact,
                exp: 'Experienced'
            },
            {
                name: 'Next.js',
                icon: faAtom,
                exp: 'Entry'
            },
            {
                name: 'Bootstrap',
                icon: faBootstrap,
                exp: 'Experienced'
            },
            {
                name: 'Material-UI',
                icon: faCode,
                exp: 'Intermediate'
            },
            {
                name: 'Socket.io',
                icon: faRocket,
                exp: 'Experienced'
            },
        ]
    },
    {
        title: 'Backend Development',
        techs: [
            {
                name: 'PHP',
                icon: faPhp,
                exp: 'Experienced'
            },
            {
                name: 'Node.js',
                icon: faNodeJs,
                exp: 'Proficient'
            },
            {
                name: 'Express.js',
                icon: faNodeJs,
                exp: 'Experienced'
            },
            {
                name: 'MySQL',
                icon: faDatabase,
                exp: 'Experienced'
            },
            {
                name: 'MongoDB',
                icon: faDatabase,
                exp: 'Intermediate'
            },
        ]
    }
]

export default techs